import React, { FC } from 'react'
import Image from 'react-bootstrap/Image'
import { Link, useLocation } from 'react-router-dom'
import powerByHLX from '../../assets/customizations/logos/HealthLX.svg'
import connectID from '../../assets/customizations/logos/ConnectID.svg'
import { appConfig } from '../../assets/customizations/config'
import './index.scss'
import { scrollToTop } from '../../utils/helpers'

const Footer: FC = () => {
  const location = useLocation()
  const isDevPage = location.pathname.includes('/developers')
  const linkText = !isDevPage ? 'For Application Developers' : 'Home'
  const linkRoute = !isDevPage ? (appConfig.developer_link ? appConfig.developer_link : '/developers') : '/login'
  const linkExternal = !isDevPage && !!appConfig.developer_link

  return (
    <footer>
      <h2 className='h3'>
        {linkExternal ? (
          <a href={linkRoute} target="_blank" rel="noopener noreferrer">{linkText}</a>
        ) : (
          <Link to={linkRoute}>{linkText}</Link>
        )}
      </h2>
      {appConfig.show_footer_links && (
        <nav id='secondary_nav' aria-label='secondary navigation'>
           <ul>
            <li><Link to="/terms" onClick={scrollToTop}>Member Terms and Conditions</Link></li>
            <li><Link to="/privacy" onClick={scrollToTop}>Member Privacy Notice</Link></li>
            <li><Link to="/cookies" onClick={scrollToTop}>Necessary Cookies Only</Link></li>
            <li><Link to="/developers" onClick={scrollToTop} >API Information</Link></li>
          </ul>
        </nav>
      )}
      <p>
        <a href="https://www.healthlx.com/connectid/" target="_blank" rel="noreferrer">
          <Image className='img-fluid' src={connectID} alt="ConnectID." />
        </a>
      </p>
      <p>
        <a href="https://www.healthlx.com" target="_blank" rel="noreferrer">
          <Image className='img-fluid' src={powerByHLX} alt="HealthLX. A TESCHGlobal Company." />
        </a>
      </p>
    </footer>
  )
}

export default Footer